import React from 'react'
import { File, FileImage, FileSpreadsheet, FileText } from 'lucide-react'

const ICON_CLASS = 'tw-size-5 tw-shrink-0'

/**
 * Returns the appropriate icon for a file extension
 * @param {string} fileExtension - The file extension
 * @returns {JSX.Element} The appropriate file icon
 */
export const getFileIcon = fileExtension => {
  switch (fileExtension.toLowerCase()) {
    case '.doc':
    case '.docx':
      return (
        <FileText
          aria-hidden="true"
          className={ICON_CLASS}
          style={{ color: 'blue' }}
        />
      )
    case '.pdf':
      return (
        <File
          aria-hidden="true"
          className={ICON_CLASS}
          style={{ color: 'red' }}
        />
      )
    case '.png':
    case '.jpg':
    case '.jpeg':
      return (
        <FileImage
          aria-hidden="true"
          className={ICON_CLASS}
          style={{ color: 'skyblue' }}
        />
      )
    case '.xls':
    case '.xlsx':
      return (
        <FileSpreadsheet
          aria-hidden="true"
          className={ICON_CLASS}
          style={{ color: 'green' }}
        />
      )
    default:
      return (
        <FileText
          aria-hidden="true"
          className={ICON_CLASS}
          style={{ color: '#9e9e9e' }}
        />
      )
  }
}
